import { BookOpen, Mail } from 'lucide-react';

const AMAZON_URL = 'https://www.amazon.com/Wealth-Any-Age-Practical-Building-ebook/dp/B0GX22ZDMC/';

const BELIEFS = [
  'Wealth is not the goal. Freedom is.',
  'Financial literacy is one of the most powerful equity tools available.',
  'The right knowledge at the right time can change the trajectory of an entire life.',
  'Research what actually works, test it with real money, share the results honestly — including the failures.',
];

export default function AuthorSection() {
  return (
    <div className="bg-[#0A1628] py-24 px-6 border-t border-slate-800/60">
      <div className="max-w-5xl mx-auto">

        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-4">
            <BookOpen size={13} className="text-amber-400" />
            <span className="text-amber-300 text-xs font-semibold tracking-wide uppercase">About the Author</span>
          </div>
          <h2 className="text-4xl font-bold text-white">Sushil Sharma</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12 items-start">
          {/* Avatar + contact */}
          <div className="flex flex-col items-center gap-6">
            <div className="w-36 h-36 rounded-full bg-gradient-to-br from-amber-500/30 to-emerald-500/20 border-2 border-amber-500/40 flex items-center justify-center shadow-xl shadow-amber-500/10">
              <span className="text-5xl font-bold text-amber-300">S</span>
            </div>
            <div className="text-center">
              <p className="text-white font-bold text-lg">Sushil Sharma</p>
              <p className="text-slate-400 text-sm">Technology Leader · Investor · Author</p>
              <p className="text-amber-400/60 text-xs mt-1">CNC Publishing, 2026</p>
            </div>
            <div className="flex flex-col gap-2 w-full">
              <a
                href={AMAZON_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-amber-500/10 hover:bg-amber-500/20 border border-amber-500/30 text-amber-400 text-sm font-semibold px-4 py-2.5 rounded-xl transition-all"
              >
                <BookOpen size={14} />
                Get the Book
              </a>
              <a
                href="mailto:tech.sushil@gmail.com"
                className="flex items-center justify-center gap-2 bg-slate-800/40 hover:bg-slate-700/40 border border-slate-700/40 text-slate-400 hover:text-slate-300 text-sm px-4 py-2.5 rounded-xl transition-all"
              >
                <Mail size={14} />
                tech.sushil@gmail.com
              </a>
            </div>
          </div>

          {/* Bio */}
          <div className="md:col-span-2 space-y-5 text-slate-300 leading-relaxed">
            <p>
              Sushil Sharma is a technology leader, active investor, and writer based in the United States. He has spent more than two decades working at the intersection of technology, business strategy, and personal finance — building products, scaling teams, and learning firsthand how the principles in this book work in the real world.
            </p>
            <p>
              Over the course of his career, Sushil has built and operated multiple side businesses in the digital and tech space, invested in real estate and early-stage companies, and applied every strategy in <span className="text-amber-300 font-medium">Wealth At Any Age</span> at some point in his own financial journey.
            </p>
            <p>
              He has experienced the panic of early career debt, the momentum of the 30s acceleration phase, and the deliberate leverage strategies that define smart 40s wealth building. His approach to personal finance is practical above all else: research what actually works, test it with real money, and share the results honestly — including the failures.
            </p>

            {/* Belief cards */}
            <div className="grid sm:grid-cols-2 gap-3 pt-2">
              {BELIEFS.map(belief => (
                <div key={belief} className="bg-slate-800/30 border border-slate-700/40 rounded-xl px-4 py-3">
                  <p className="text-slate-300 text-sm italic leading-relaxed">"{belief}"</p>
                </div>
              ))}
            </div>

            <blockquote className="border-l-2 border-amber-400 pl-4 text-amber-200/80 italic mt-2">
              "To everyone who ever felt too late, too broke, or too far behind to begin — you are none of those things. This book is for you."
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  );
}
